module.exports = __webpack_public_path__ + "media/luna50alu.8ce25a13.mp4";